// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","controls_multiCity":"controls_multiCity-RmEXu","controls":"controls-3txk3"};